export default "__VITE_PUBLIC_ASSET__e0575a3f__"